import { render, staticRenderFns } from "./DropOffSlotSelection.vue?vue&type=template&id=023cbf5f&scoped=true&"
import script from "./DropOffSlotSelection.vue?vue&type=script&lang=ts&"
export * from "./DropOffSlotSelection.vue?vue&type=script&lang=ts&"
import style0 from "./DropOffSlotSelection.vue?vue&type=style&index=0&id=023cbf5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023cbf5f",
  null
  
)

export default component.exports